import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import PersonIcon from '@material-ui/icons/Person';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: 'white',
    border: 'none',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

export default function AdminDemandModel(props) {
  const classes = useStyles();
  var t = true;
  const handleClose = () => {
    t = false;
  }
  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={props.open && t}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={props.open && t}>
          <div className={classes.paper}>
            <PersonIcon style={{ color: '#00BBBB', fontSize: '200', marginLeft: '25%', marginRight: '25%' }} />
            <h3 style={{ color: '#00BBBB' }}>The ware house details have been saved into database.</h3>
          </div>
        </Fade>
      </Modal>
    </div>
  );
}
